angular.module('dental')
    .directive('logoLoad', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            link($scope, $element, $attrs) {
                if ($attrs.src === undefined) {
                    var testImageSrc = $attrs.checksrc,
                        defaultURL = '/assets/images/logo.png';

                    var s = document.createElement('IMG');
                    s.src = testImageSrc;
                    s.onerror = function(){
                        testImageSrc = defaultURL;
                    };

                    $attrs.$set('src', testImageSrc);
                    $compile($element)($scope);
                }
            }
        };
    }]);